<div class="modal-header bg-light">
  <div>
    <h4 class="modal-title fw-bold mb-0">Nota de Venta #{{ sale?.id }}</h4>
    <small class="text-muted">{{ sale?.created_at | date:'dd/MM/yyyy HH:mm:ss' }}</small>
  </div>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <!-- Información del Sistema -->
  <div class="card bg-light-warning mb-4">
    <div class="card-body p-3">
      <h6 class="card-title text-dark mb-3">
        <i class="fas fa-database me-2"></i>Información del Sistema
      </h6>
      <p class="card-text mb-1"><strong>Cliente registrado:</strong> {{ sale.customer?.name }}</p>
      <p class="card-text mb-0"><strong>Vendedor:</strong> {{ sale.user?.full_name }}</p>
    </div>
  </div>

  <!-- Detalles de la Nota de Venta -->
  <div class="card mb-4">
    <div class="card-body p-3">
      <h6 class="card-title text-primary mb-3">
        <i class="fas fa-file-invoice me-2"></i>Detalles de la Venta
      </h6>
      <div class="row g-3">
        <div class="col-md-6">
          <p class="mb-2"><strong>A nombre de:</strong> {{ sale.customer?.name_sin }}</p>
          <p class="mb-2"><strong>ID Cliente:</strong> {{ sale.customer?.document }} - {{ sale.customer?.number_document
            }}</p>
          <p class="mb-2"><strong>Tipo de Venta:</strong> <span class="badge"
              [ngClass]="sale.type_price === 1 ? 'badge-light-warning' : 'badge-light-success'">{{ sale.type_price === 1
              ? 'Sin factura' : 'Con factura' }}</span></p>

        </div>
        <div class="col-md-6">
          <p class="mb-2"><strong>Tipo de Pago:</strong> <span class="badge badge-light-primary">{{ sale.type_payment
              }}</span></p>
          <p class="mb-2"><strong>Observaciones:</strong> {{ sale.obs || 'N/A' }}</p>
        </div>
      </div>
    </div>
  </div>

  <!-- Lista de Productos -->
  <div class="card">
    <div class="card-body p-3">
      <h6 class="card-title text-success mb-3">
        <i class="fas fa-shopping-cart me-2"></i>Productos
      </h6>
      <div class="table-responsive">
        <table class="table table-hover align-middle">
          <thead class="bg-light">
            <tr>
              <th style="width: 30%;" class="text-dark">Producto</th>
              <th style="width: 20%;" class="text-dark">SKU</th>
              <th style="width: 10%;" class="text-center text-dark">Cantidad</th>
              <th style="width: 20%;" class="text-end text-dark">Precio Unit.</th>
              <th style="width: 20%;" class="text-end text-dark">Subtotal</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of PRODUCTS">
              <td>
                <div class="d-flex align-items-center">
                  <span class="text-dark fw-semibold">{{ item.name }}</span>
                </div>
              </td>
              <td class="text-muted">{{ skuMap[item?.product_id] || '' }}</td>
              <td class="text-center">
                <span class="badge badge-light-primary">
                  {{ item.quantity }}
                </span>
              </td>
              <td class="text-end">
                {{ (
                sale.type_price === 1 ?
                (item.promotion_price_regular || item.price_regular) :
                (item.promotion_price_tax || item.price_tax)
                )| number:'1.2-2'
                }} Bs.
              </td>
              <td class="text-end fw-bold">
                {{ (
                sale.type_price === 1 ?
                (item.promotion_price_regular || item.price_regular) * item.quantity :
                (item.promotion_price_tax || item.price_tax) * item.quantity )
                | number:'1.2-2'
                }} Bs.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Resumen de Totales -->
      <div class="border-top pt-3 mt-3">
        <div class="row justify-content-end">
          <div class="col-md-5">
            <div class="bg-light-success rounded p-3">
              <div class="d-flex justify-content-between mb-2">
                <span class="text-gray-600">Subtotal:</span>
                <span class="fw-bold">{{ sale.total_sale | number:'1.2-2'}} Bs.</span>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <span class="text-gray-600">Descuento:</span>
                <span class="fw-bold text-danger">- {{ sale.discount | number:'1.2-2'}} Bs.</span>
              </div>
              <div class="d-flex justify-content-between border-top pt-2">
                <span class="text-gray-900 fw-bold">Total a Pagar:</span>
                <span class="fw-bolder fs-5 text-success">{{ sale.total_to_pay | number:'1.2-2'}} Bs.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer bg-light">
  <button class="btn btn-secondary" (click)="activeModal.close()">
    <i class="fas fa-times me-2"></i>Cerrar
  </button>
</div>
